import { render } from "./WebSales.vue?vue&type=template&id=80cb78f6"
import script from "./WebSales.vue?vue&type=script&lang=js"
export * from "./WebSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Sales/WebSales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80cb78f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80cb78f6', __exports__)) {
    api.reload('80cb78f6', __exports__)
  }
  
  module.hot.accept("./WebSales.vue?vue&type=template&id=80cb78f6", () => {
    api.rerender('80cb78f6', render)
  })

}


export default __exports__